import type { EditorCommand } from '@atlaskit/editor-common/types/editor-command';

import { malleableUiPluginKey } from '../pm-plugins/plugin-key';

/** Shows the "Output adjusted" flag (backend produced a different type than selected). */
export const showSubtypeAdjustedFlag =
	(): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, { showSubtypeAdjustedFlag: true });
		return tr;
	};

/** Dismisses the "Output adjusted" flag. */
export const dismissSubtypeAdjustedFlag =
	(): EditorCommand =>
	({ tr }) => {
		tr.setMeta(malleableUiPluginKey, { showSubtypeAdjustedFlag: false });
		return tr;
	};
